export const getScore = (corrections, penalty) => {
    const numIncorrectWords = corrections.flat().reduce((acc, currentCorrection) => {
        if (!currentCorrection.isCorrect) {
            const words = currentCorrection.expected.split(" ");
            acc += words.length;
        }
        return acc
    }, 0);

    return numIncorrectWords * penalty;
};